export enum Model {
  project = 'Project',
  opex = 'Opex',
  capex = 'Capex',
  credit = 'Credit',
  leasing = 'LeasingContract',
  ownCapital = 'OwnFund',
  workingCapital = 'WorkingCapitalParameter',
  advancedProduct = 'AdvancedProduct',
  standartsProduct = 'StandardProduct',
  taxMin = 'TaxMin',
  taxStandard = 'TaxStandard',
  taxSpecial = 'TaxSpecial',

  // 'capital-investments' = 'Capex',
  // 'sales-and-revenue-calculation' = 'Opex',
  // 'loan-modeling' = 'Credit',
  // 'advanced-product' = 'AdvancedProduct',
  // 'standarts-product' = 'StandardProduct',
  // 'modeling-of-equity-contributions' = 'OwnFund',
  // 'modeling-working-capital' = 'WorkingCapitalParameter',
  // 'leasing-modeling' = 'LeasingContract',
  // 'setting-up-tax-calculations' = 'TaxMin',
  // 'setting-up-tax-calculations' = 'TaxStandard',
  // 'setting-up-tax-calculations' = 'TaxSpecial',
}
